import React from 'react';
import logo from '../../img/logos/dp-logo.png';

class SplashScreen extends React.Component {

    render() {

        return (

            <div className="splash-screen"><img src={logo} alt="Logo" className="logo" /></div>

        );

    }

}

export default SplashScreen;